import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';

//import Button from 'shared/Button';
import { withAppContext } from '../../../contexts/app';

import ImageUploader from '../../../components/ImageUploader';

import SidebarMenu from '../../../layout/SidebarMenu';
//import SidebarAdPlaceholder from 'images/ask/placeholders/ad-space.svg';

class Sidebar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="sidebar condition__sidebar">
        <div className="content">
          {/* <Button className="condition__sidebar__follow-condition-btn">Follow this condition</Button> */}

          <SidebarMenu
            items={this.props.menuItems}
            onItemClick={this.props.onItemClick}
            top={this.sidebarTop()}
          />

          {/*
          <div className="condition__sidebar__ad-space">
            <img src={SidebarAdPlaceholder} />
          </div>
          */}

        </div>
      </div>
    );
  }

  sidebarTop() {
    if (this.props.fromConditionResults) { return; }

    return (
      <div className="condition__sidebar__top">
        <div className="condition__sidebar__top__left">
          <p>If you think you have {this.props.conditionName.toLowerCase()}, get a second opinion with Triage’s state of the art skin checker.</p>
        </div>

        <div className="condition__sidebar__top__right">
          {/*
          <Link
            to="/get-started"
            className={`condition__sidebar__top-button${this.props.severeCondition ? ' severe' : ''}`}
          >
            Get Started
          </Link>
          */}

          <ImageUploader
            className={`button button--medium button--gradient condition__sidebar__top-button${this.props.severeCondition ? ' severe' : ''}`}
            label="Check your skin"
            onUpload={this.onImageUpload.bind(this)}
          />
        </div>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

Sidebar.defaultProps = {
  severeCondition: false,
  fromConditionResults: false,
  onItemClick: ()=>{},
  menuItems: undefined,
};

Sidebar.propTypes = {
  app: PropTypes.object.isRequired,
  severeCondition: PropTypes.bool,
  fromConditionResults: PropTypes.bool,
  menuItems: PropTypes.array,
  onItemClick: PropTypes.func,
  conditionName: PropTypes.string.isRequired
};

export { Sidebar };
export default withAppContext(Sidebar);
